var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppleLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 0.833984C12.4767 0.889818 11.3736 1.4251 10.7178 2.10677C10.1253 2.72677 9.6578 3.64758 9.84863 4.53841C10.8928 4.56591 11.9409 4.01676 12.5684 3.32259C13.1542 2.67342 13.5983 1.76732 13.4375 0.833984ZM13.4945 4.53678C11.987 4.53678 11.3567 5.46289 10.3125 5.46289C9.23833 5.46289 8.25638 4.59538 6.95638 4.59538C5.18805 4.59621 2.5 6.23426 2.5 10.0934C2.5 13.6043 5.68138 17.5007 7.47721 17.5007C8.56805 17.5115 8.8325 16.8148 10.3125 16.8073C11.7942 16.7965 12.1139 17.5098 13.2064 17.5007C14.4364 17.4915 15.397 16.1398 16.0986 15.069C16.602 14.3023 16.8089 13.9109 17.1989 13.0443C14.3047 12.3109 13.7289 7.64371 17.1989 6.67871C16.5439 5.56121 14.632 4.53678 13.4945 4.53678Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple-logo.e8b20838cd0d38479d01ba43c1851e30.svg";